import React from 'react';
import useMapSVGOverlayStyles from './styles';
import OutlineFilter from '../SvgPathDefs/OutlineFilter';
import BoldFilter from '../SvgPathDefs/BoldFilter';
import BoldFilterSelected from '../SvgPathDefs/BoldFilterSelected';
import SelectedFilter from '../SvgPathDefs/SelectedFilter';

export const MapSVGOverlay: React.FunctionComponent = ({ children }) => {
  const classes = useMapSVGOverlayStyles();
  return (
    <div className={classes.outline}>
      <svg className={classes.svg}>
        <defs>
          <OutlineFilter />
          <BoldFilter />
          <BoldFilterSelected />
          <SelectedFilter />
        </defs>
        {children}
      </svg>
    </div>
  );
};
